import { render, staticRenderFns } from "./ChatOrderProfileCard.vue?vue&type=template&id=49acfc49&scoped=true&"
import script from "./ChatOrderProfileCard.vue?vue&type=script&lang=js&"
export * from "./ChatOrderProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderProfileCard.vue?vue&type=style&index=0&id=49acfc49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49acfc49",
  null
  
)

export default component.exports